<template>
  <div
    class="tw-w-4 tw-h-4 tw-rounded-full tw-border tw-border-neutral-300 tw-grid tw-place-items-center tw-text-xs tw-text-neutral-300 tw-select-none"
    v-tooltip="{
      content,
      placement,
      html: true,
    }"
  >
    i
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    title?: string
    tooltip: string | object
    placement: string
  }>(),
  {
    title: '',
    placement: 'top',
  },
)

const content = computed(() => {
  if (props.title) {
    return `<div class='tw-heading-5 tw-mb-2 tw-text-white'>${props.title}</div><div class='tw-text-neutral-400'>${props.tooltip}</div>`
  }

  return props.tooltip
})
</script>
